module.exports = __webpack_public_path__ + "static/MaterialCommunityIcons-3c851d60ad5ef3f2fe43ebd263490d78.ttf";